import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { ShowInfoStudentsDialogComponent } from 'src/app/components/show-info-students-dialog/show-info-students-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { RescheeduleDialogComponent } from 'src/app/components/rescheedule-dialog/rescheedule-dialog.component';
import { ReportDialogComponent } from 'src/app/components/report-dialog/report-dialog.component';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: [
    '../../../../../shared-styles/classes.scss'
  ],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
  public isMobile: any;
  public headerHeight: any = 0;
  public paginate: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public dataSource = [];
  public students: any = [];
  public displayedColumns: string[] = [
    'lesson_name',
    'date',
    'duration',
    'status',
    'actions',
    'income',
  ];
  public isTeacher = true;
  public user: any;
  public userInfo: any;
  public classesLength: any = 0;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private dialog: MatDialog
  ) {
    this.isMobile = this.general.isMobile();

  }

  async ngOnInit() {
    try {
      this.general.setLoading(true);
      window.dispatchEvent(new CustomEvent('calendar-hide-label'));
      this.intializeSubscriptions();
      await this.getUserInfo();
      await this.getStudentsWithClasses();
    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  // Handle event Listener
  handleEvent(event: any) {
    switch (event.type) {
    }
  }

  async getStudentsWithClasses() {
    const response = await this.general.httpGet(
      'my-students-with-teacher-classes'
    );

    this.students = response.data.map((e: any) => {
      e.classes = this.formatClasses(e.classes);
      e.paginate = 0;
      return e;
    });
  }

  async getClasses(index: any) {
    const response = await this.general.httpGet('teacher-class-mine', {
      student_id: this.students[index].id,
      page: this.students[index].paginate + 1,
    });

    this.students[index].classes = this.formatClasses(response);
  }

  async onChangePage($event: any, index: any) {
    this.students[index].paginate = $event.pageIndex;
    await this.getClasses(index);
  }

  async onActionClass(element: any, indexStudent: any, action: any) {
    switch (action) {
      case 'complete':
        await this.sendActionToAPI(element, indexStudent, action);
        break;
      case 'cancel':
        await this.cancelClass(element, indexStudent, action);
        break;
      case 'reschedule':
        await this.rescheduleClass(element, indexStudent, action);
        break;
      case 'report-incident':
        await this.reportClass(element, indexStudent, action);
        break;
    }
  }

  async onChatStudent(student: any) {
    const chat = {
      user_id: student.id,
      name: student.name,
      user_photo: student.profile_photo_path,
      last_message: null,
    };

    localStorage.setItem('current-chat', JSON.stringify(chat));
    await this.general.sleep(10);
    await this.general.navigate('messages');
  }

  formatClasses(classes: any) {
    return classes.map((e: any) => {
      const timezone = this.general.getCurrentTimezone();

      const datetime = DateTime.fromFormat(e.start, 'yyyy-LL-dd HH:mm:ss', {
        zone: 'UTC',
      }).setZone(timezone);

      const date = this.isMobile
        ? datetime.toFormat('dd/LL HH:mm')
        : datetime.toFormat('dd/LL/yyyy HH:mm');

      const end = DateTime.fromFormat(e.start, 'yyyy-LL-dd HH:mm:ss', {
        zone: 'UTC',
      })
        .setZone(timezone)
        .plus({ hour: 1 })
        .toMillis();

      const now = DateTime.local().setZone(timezone).toMillis();

      if (now > end && e.state === '1') {
        e.state = '0';
      }

      return {
        ...e,
        date: date,
        state: Number.parseInt(e.state),
      };
    });
  }

  showStudentInfo(student: any) {
    const dialogRef = this.dialog.open(ShowInfoStudentsDialogComponent, {
      data: {
        student,
      },
      autoFocus: false,
      maxWidth: '600px',
    });
  }

  async sendActionToAPI(element: any, indexStudent: any, action: any) {
    try {
      this.general.setLoading(true);
      const response = await this.general.httpPost(
        'teacher-class-update-state',
        {
          action,
          id: element.id,
        }
      );

      // await this.getClasses();
    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
  }

  async cancelClass(element: any, indexStudent: any, action: any) {
    await this.sendActionToAPI(element, indexStudent, action);
    this.setStateClass(element, indexStudent, 3);
  }

  async rescheduleClass(element: any, indexStudent: any, action: any) {
    // Check Time Class
    const res = this.checkLessThanThreeHoursFromNow(element.start);

    if (res) {
      return;
    }
    const dialogRef = this.dialog.open(RescheeduleDialogComponent, {
      data: {
        teacherId: this.user.id,
        maxHours: 1,
        title: 'select-the-new-hour',
      },
      autoFocus: false,
      maxHeight: '800px',
      maxWidth: '600px',
      width: '100%',
      height: '100%',
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        this.general.setLoading(true);
        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        const res = await this.general.httpPost('booking-reschedule', {
          booking_start_datetime: data.booking_start_datetime,
          booking_end_datetime: data.booking_end_datetime,
          booking_id: element.booking_id,
        });
        const teacher_class: any = this.students[indexStudent].classes.find(
          (data: any) => data.id === element.id
        );
        if (!teacher_class) {
          return;
        }
        teacher_class.state = 1;
        teacher_class.start = DateTime.fromISO(data.booking_start_datetime)
          .setZone('UTC')
          .toFormat('yyyy-LL-dd HH:mm:ss');

        const date = this.isMobile
          ? DateTime.fromISO(data.booking_start_datetime)
              .setZone(this.general.getCurrentTimezone())
              .toFormat('dd/LL HH:mm')
          : DateTime.fromISO(data.booking_start_datetime)
              .setZone(this.general.getCurrentTimezone())
              .toFormat('dd/LL/yyyy HH:mm');
        teacher_class.date = date;
      } catch (e: any) {
        console.log(e);
      } finally {
        this.general.setLoading(false);
      }
    });
  }

  async reportClass(element: any, indexStudent: any, action: any) {
    const dialogRef = this.dialog.open(ReportDialogComponent, {
      data: {
        title: 'report-incidence-text',
      },
      autoFocus: false,
      maxHeight: '400px',
      maxWidth: '600px',
      width: '100%',
      height: '100%',
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        this.general.setLoading(true);

        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        await this.general.httpPost('dispute-open', {
          booking_id: element.booking_id,
          type: 'booking',
          message: data,
        });

        this.setStateClass(element, indexStudent, 5);
      } catch (e: any) {
        console.log(e);
      } finally {
        this.general.setLoading(false);
      }
    });
  }

  checkLessThanThreeHoursFromNow(date: any) {
    const timezone = this.general.getCurrentTimezone();
    const start = DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss', {
      zone: 'UTC',
    })
      .setZone(timezone)
      .toMillis();
    const now = DateTime.local().setZone(timezone).toMillis();
    return now > start - 1000 * 60 * 60 * 3;
  }

  setStateClass(element: any, index: number, state: number) {
    const teacher_class: any = this.students[index].classes.find(
      (data: any) => data.id === element.id
    );
    if (!teacher_class) {
      return;
    }
    teacher_class.state = state;
  }
}
